import {Component, OnInit, ViewChild} from '@angular/core';
import {PackshotVideoLonginesOrderInterface} from '../../../models/sharedinterface';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {ApiFactoryService} from '../../../shared/services/api-factory.service';
import {I18nService} from '../../../shared/services/i18n.service';
import {Router} from '@angular/router';
import {ShareddataService} from '../../../shared/services/shareddata.service';
import {GlobalsService} from '../../../shared/services/globals.service';
import {HttpClient} from '@angular/common/http';
import {AuthenticationService} from '../../../security/authentication.service';
import * as moment from 'moment';
import {BcApi} from '../../../models/bc-api';

@Component({
  selector: 'app-packshot-video-longines-orders',
  templateUrl: './packshot-video-longines-orders.component.html',
  styleUrls: ['./packshot-video-longines-orders.component.scss']
})
export class PackshotVideoLonginesOrdersComponent implements OnInit {

  serverRoot: string;

  bcApi: BcApi;

  // show search
  public showSearch: boolean;

  public filterObject: {
    filtervalue: string;
  } = {
    filtervalue: '',
  };

  // current order
  public currentOrder: PackshotVideoLonginesOrderInterface;

  // export options
  public exportOptions = {
    fileName: 'Export packshots video orders',
    sheet: this.i18n.get('orders_export_sheetname', 'orders'),
  };

  displayedColumns: any = [];
  keyColumns: any = []; // Columns with link
  datalistsource: MatTableDataSource<any>; // MatTableDataSource
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(
    private apifactory: ApiFactoryService,
    public i18n: I18nService,
    private router: Router,
    private shareData: ShareddataService,
    private globalService: GlobalsService,
    private http: HttpClient,
    private authservice: AuthenticationService
  ) {

    this.bcApi = this.apifactory.createBcApi();
    this.serverRoot = this.globalService.getBCapiroot();

    this.currentOrder = null;
  }

  ngOnInit(): void {
    this.displayedColumns = ['ordernr', 'orderdate', 'username', 'actions'];
    this.keyColumns = ['id'];

    const query = this.bcApi.getRecentOrders();
    query.subscribe((allresults: any) => {

        this.datalistsource = new MatTableDataSource(allresults.results);
        this.datalistsource.sort = this.sort;
        this.datalistsource.paginator = this.paginator;
        this.onDataSourceReady();
      },
      error => {
        if (error.status === 403) { // Session expired
          this.authservice.setLoggedin(false);
          this.router.navigate(['']);
        }
      });

  }

  onDataSourceReady() {
    this.datalistsource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'date':
          return new Date(item.date.date);
        default:
          return item[property];
      }
    };
    this.datalistsource.filterPredicate = this.filterPredicateHandler.bind(this);
  }

  applyFilter($event?: Event) {
    this.datalistsource.filter = JSON.stringify(this.filterObject);
  }

  getColumnLabel(fieldName: string) {
    switch (fieldName) {
      case 'ordernr':
        return 'Order Nr.';
      case 'orderdate':
        return 'Ordered on';
      case 'username':
        return 'Ordered by';
      case 'actions':
        return '';
      default:
        return fieldName;
    }
  }

  getFormattedValue(fieldName: string, value: any) {
    if (fieldName === 'orderdate') {
      return moment(value.date).format('DD/MM/YYYY HH:mm');
    }
    return value;
  }

  filterPredicateHandler(inputData, filter: string): boolean {

    const filterObject = JSON.parse(filter);

    // Global text filtering
    let textCriteria = true;
    if (filterObject?.filtervalue !== '') {
      const nrCriteria = this.containsLowercaseFilter(inputData.ordernr, filterObject.filtervalue);
      const orderDateCriteria = this.containsLowercaseFilter(inputData.orderdate, filterObject.filtervalue);
      const orderUsernameCriteria = this.containsLowercaseFilter(inputData.username, filterObject.filtervalue);
      const orderEmailCriteria = this.containsLowercaseFilter(inputData.useremail, filterObject.filtervalue);

      textCriteria = nrCriteria || orderDateCriteria || orderUsernameCriteria || orderEmailCriteria;
    }

    const filteredIn = textCriteria;

    return filteredIn;
  }

  containsLowercaseFilter(data: any, filter: string) {
    data = String(data);
    const treatedfilter = filter.trim().toLowerCase();
    const treateddata = data.trim().toLowerCase();

    const searchresult = treateddata.search(treatedfilter);
    if (searchresult === -1) { // No match
      return false;
    } // if
    return true;
  }

  openDetails(order: PackshotVideoLonginesOrderInterface) {
    this.currentOrder = order;
  }

  closeDetails() {
    this.currentOrder = null;
  }

  renewOrder(order: PackshotVideoLonginesOrderInterface) {
    // Redirect to the only aos prod tool of the mandant with autologin info

    /**
     * TODO
     */
    /**
     const renewPath = this.globalService.getAosProdRenewPath(
     this.shareData.getCurrentlanguage(),
     this.shareData.getUserTools(), order);

     this.router.navigate(renewPath);
     */
  }

}
